export default function getRemainingOptionsCount(modifier, count) {
  const {min, optional} = modifier
  if (optional && count === 0) return 0
  const remainingOptions = min - count
  return remainingOptions < 0 ? 0 : remainingOptions
}
